
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pro-series/[category]",
      function () {
        return require("private-next-pages/pro-series/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pro-series/[category]"])
      });
    }
  